/* eslint-disable no-unused-vars */
import React, { Component } from 'react'

import { gql } from '@apollo/client'
import { Dialog, Slide } from '@material-ui/core'

//import Loading from '../../../components/loading'
import {Loading} from '../../../../components/Loading/Loading'
import HistoryOpener from "./HistoryTable"
import InventoryAssociationsHistoryOpener from './InventoryAssociationsHistory'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class PopupData extends Component {
    state = {
        open: false,
        data: '',
    }

    handleClose = (event) => {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        this.setState({
            open: false,
        });

        this.props.close()
    };

    render() {
        const { client, openD, close, id, TableObject, handleSetFilters, classes } = this.props;
        const handleClose = this.handleClose;
        const Get_data = gql`
            query ($id:String!){
                ${TableObject.unitQueryBuilder.toString()}
            }
        `;

        const showAssociationPanel = TableObject.getShowPopupInventoryAssociations()
        const showChangeeHistoryPanel = TableObject.getShowPopupChangeHistoryPanel()

        return (
            <Dialog
                open={openD}
                maxWidth={false}
                scroll="body"
                fullWidth
                TransitionComponent={Transition}
                disableEnforceFocus
                classes={{ paperFullWidth: classes.dialogWidth }}
                onClose={handleClose}
                id={'pickerDialog' + id}
            >
                <div onClick={(event) => event.stopPropagation()}>
                    <Loading query={Get_data} variables={{ id: id }} fetchPolicy="network-only">
                        {(data, refetch) => {
                            return (
                                <div>
                                    <span onClick={handleClose} style={{ fontSize: '1.5em', cursor: 'pointer', position: 'absolute', right: '10px', top: '5px' }}>&times;</span>
                                    {TableObject.popupContentStrategy({
                                        data: TableObject.popupMapper(data),
                                        refetch: refetch,
                                        close: this.handleClose,
                                        handleSetFilters: handleSetFilters,
                                        TableObject: TableObject
                                    })}
                                    {showAssociationPanel ?
                                        <div key={'inv_assoc_pnl'} style={{ float: "left" }}>
                                            <InventoryAssociationsHistoryOpener data={data} />
                                        </div>
                                    : null}
                                    {showChangeeHistoryPanel ?
                                        <div key={'chg_hist_pnl'} style={{ float: "right" }}>
                                            <HistoryOpener data={data} />
                                        </div>
                                    : null}
                                </div>
                            )
                        }
                        }
                    </Loading>
                </div>
            </Dialog>
        )
    }
}

export default PopupData
